import React from "react";
import {
    BarChart3,
    FileSignature,
    Globe,
    Images,
    LayoutDashboard,
    Newspaper,
    Smartphone,
} from "lucide-react";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "ozet", label: "Komuta Özeti", icon: LayoutDashboard },
    { id: "slider", label: "Slider", icon: Images },
    { id: "haberler", label: "Haberler", icon: Newspaper },
    { id: "istatistikler", label: "İstatistikler", icon: BarChart3 },
    { id: "basvuru-formlari", label: "Web Başvuruları", icon: FileSignature },
    { id: "pwa", label: "PWA", icon: Smartphone },
];

export default function SiteYonetimiMerkezLayout() {
    return (
        <MerkezHubShell
            title="Site Yönetimi"
            subtitle="mbshukuk.com kamu sitesi — slider, haberler, sayaçlar, form başvuruları ve PWA tek merkezde."
            badge="Kamu Site · CMS"
            basePath="/yeni/site-yonetimi"
            tabs={TABS}
        />
    );
}
